export default "__VITE_ASSET__Cll1cgQb__"